<template>
  <li
    class="comment p-2"
    @click.stop>
    <div class="d-flex align-items-center justify-content-between">
      <div class="comment__content d-flex align-items-center mb-2">
        <img
          v-if="comment.createdBy.avatar"
          :src="comment.createdBy.avatar"
          class="img-fluid comment__img rounded-circle mr-2">
        <b-avatar 
          v-else
          class="mr-2 my-1"
          size="30px"
          :text="comment.createdBy.name | initial" />
        <p class="comment__name mr-2">
          {{ comment.createdBy.name }}
        </p>
        <p class="comment__date">
          {{ comment.updatedAt | prettyDateTime }}
        </p>
      </div>
      <div
        v-if="isCommentedByLoginUser"
        class="comment__delete">
        <button
          class="btn btn--delete btn--small"
          @click="deleteComment">
          <span class="comment__icon material-icons">
            delete
          </span>
        </button>
      </div>
    </div>
    <div 
      :class="commentBodyClass"
      class="pl-6">
      <div class="comment__detail">
        <!-- eslint-disable -->
        <p v-html="sanitizedLink(comment.detail)" class="comment__detail-text" />
        <!-- eslint-enable -->
        <file-viewer
          v-if="attachmentOption && comment.file"
          class="mt-1"
          :file="comment.file"
          :thumbnail="comment.thumbnail" />
      </div>
    </div>
  </li>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import sanitizedLinkMixin from '@/components/mixin/sanitizedLink'
import FileViewer from '@/components/parts/FileViewer'

export default {
  components: {
    FileViewer
  },
  mixins: [sanitizedLinkMixin],
  props: {
    comment: {
      type: Object,
      required: true
    },
    deleteComment: {
      type: Function,
      default: () => {}
    },
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('tenant', ['attachmentOption']),
    commentBodyClass() {
      if (this.isLatestComment) {
        return 'comment__body'
      }
      return 'comment__body--received'
    },
    isCommentedByLoginUser() {
      return this.comment.createdBy.id === this.user.id
    },
  },
  methods: {
    scrollToComment() {
      this.$nextTick(() => {
        const rect = this.$el.getBoundingClientRect()
        const elementTop = rect.top + window.pageYOffset
        const offset = 60
        window.scrollTo(0, elementTop - offset)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.comment {
  background-color: $grey15;
  list-style: none;
  &__img {
    width: 30px;
    height: 30px;
    object-fit: cover; 
  }
  &__name {
    font-weight: bold;
    font-size: $fs-s;
  }
  &__date {
    font-size: $fs-s;
  }
  &__delete {
    text-align: right;
  }
  &__body {
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
    &--received{//棒線がつくやりとりにのみつくクラス
      position: relative;
      &:before {
        content: "";
        background: $grey09;
        width: 1px;
        height: 100%;
        display: block;
        position: absolute;
        left: 15px;
      }
    }
  }
  &__icon{
    font-size: 20px;
  }
  &__detail {
    white-space: pre-line;
    word-wrap: break-word; 
  }
}
</style>